import { css as emotionCSS } from '@emotion/react';
import type { Theme } from '@mildang/mui';
import { Typography as Typography } from '@mildang/mui';
import { Button as Button } from '@mildang/mui';
import { AddIcCall as AddIcCallIcon } from '@mui/icons-material';
import { Place as PlaceIcon } from '@mui/icons-material';
import { MailOutlined as MailOutlinedIcon } from '@mui/icons-material';
import IHateFlyingBugsLogo from 'svgs/logo/IHateFlyingBugsLogo';
import FooterIconValueInfo from './FooterIconValueInfo';

const rootStyle = (theme: Theme) => emotionCSS`
  background-color: ${theme.palette.primary.darkActive};
  padding: 40px 0px 32px 0px;

  ${theme.breakpoints.down('sm')} {
    padding-top: 60px;
    padding-bottom: 28px;
  }
`;

const linkStyle = emotionCSS`
  color: white;
  opacity: 0.8;
`;
const companyInfoStyle = emotionCSS`
  opacity: 0.6;
  color: white;
`;
const containerStyle = (theme: Theme) => emotionCSS`
  width: 100%;
  margin: auto;
  padding-left: 24px;
  padding-right: 24px;
  ${theme.breakpoints.up('md')} {
    padding-right: 32px;
    padding-left: 32px;

    max-width: ${1140 + Number(32) * 2}px;
  }
`;
const infoStyle = (theme: Theme) => emotionCSS`
  ${theme.breakpoints.down('sm')} {
    display: block;
    margin-bottom: 4px;
  }
`;
const lastInfoStyle = (theme: Theme) => emotionCSS`
  ${infoStyle(theme)}
  ${theme.breakpoints.down('sm')} {
    margin-bottom: 0px;
  }
`;

const Pipe = ({ showMobile = false }: { showMobile?: boolean }) => {
  return (
    <Typography
      variant="caption1_R"
      css={(theme: Theme) => emotionCSS`
        margin-right: 4px;
        margin-left: 4px;
        opacity: 0.5;
        color: white;
        ${theme.breakpoints.down('sm')} {
          ${
            !showMobile &&
            emotionCSS`
            display: none;
          `
          }
        }
      `}
    >
      |
    </Typography>
  );
};

export interface FooterInfoProps {
  termsHref?: string;
  privacyHref?: string;
}

const FooterInfo = (props: FooterInfoProps) => {
  const { termsHref = '/terms/20220902', privacyHref = '/privacy/20250611' } = props;

  return (
    <div css={rootStyle}>
      <div css={containerStyle}>
        <div
          css={(theme: Theme) => emotionCSS`
            display: flex;
            justify-content: space-between;

            ${theme.breakpoints.down('sm')} {
              flex-direction: column;
              gap: 4px;
            }
          `}
        >
          <IHateFlyingBugsLogo
            css={emotionCSS`
              color: white;
              width: 233px;
              height: 36px;
            `}
          />
          <div
            css={(theme: Theme) => emotionCSS`
              display: grid;
              gap: 16px;
              grid-template-columns: auto auto;
              align-items: center;
              ${theme.breakpoints.down('sm')} {
                justify-content: start;
              }
            `}
          >
            <Button href={termsHref} size="small" css={linkStyle} variant="text" color="inherit">
              이용약관
            </Button>
            <Button href={privacyHref} size="small" css={linkStyle} variant="text" color="inherit">
              개인정보처리방침
            </Button>
          </div>
        </div>

        <div
          css={(theme: Theme) => emotionCSS`
            margin-top: 32px;
            gap: 4px;
            display: grid;
            ${theme.breakpoints.down('sm')} {
              margin-top: 28px;
            }
          `}
        >
          <FooterIconValueInfo icon={<AddIcCallIcon />} label="1899-0508" />
          <FooterIconValueInfo icon={<PlaceIcon />} label="서울 영등포구 여의대로 108 파크원 타워1, 39층" />
          <FooterIconValueInfo icon={<MailOutlinedIcon />} label="cs@ihateflyingbugs.com" />
        </div>

        <div
          css={(theme: Theme) => emotionCSS`
            margin-top: 32px;
            display: grid;
            gap: 4px;
            ${theme.breakpoints.down('sm')} {
              margin-top: 28px;

              gap: 0px;
            }
          `}
        >
          <Typography component="div" css={companyInfoStyle} variant="caption1_R">
            <span css={infoStyle}>{'사업자등록번호 : 101-86-69359'}</span>
            <Pipe />
            <span css={infoStyle}>{'학원설립 운영등록번호 : 제5962호 밀당피티(PT)원격학원'}</span>
            <Pipe />
            <span css={infoStyle}>{'호스팅서비스 : 아이헤이트플라잉버그스 ㈜'}</span>
          </Typography>
          <Typography component="div" css={companyInfoStyle} variant="caption1_R">
            <span css={infoStyle}>{'통신판매업신고 : 2013-서울마포-1269'}</span>
            <Pipe />
            <span css={lastInfoStyle}>{'신고기관명 : 서울특별시 남부교육지원청'}</span>
          </Typography>
        </div>

        <div
          css={(theme: Theme) => emotionCSS`
            border-top: 1px solid #55575e;
            margin-top: 40px;
            padding-top: 32px;
            display: grid;
            grid-template-columns: auto auto;
            justify-content: space-between;

            ${theme.breakpoints.down('sm')} {
              margin-top: 60px;
              padding-top: 28px;

              grid-template-columns: auto;
              gap: 4px;
            }
          `}
        >
          <Typography css={companyInfoStyle} variant="caption1_R">
            ⓒihateflyingbugs all right reserved.
          </Typography>
          <Typography css={linkStyle} variant="caption1_R">
            {'아이헤이트플라잉버그스 (주)'}
            <Pipe showMobile />
            {'대표자 : 박찬용'}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default FooterInfo;
